
/**
 * Directive to add extra functions to handle "are you sure?" questions, e.g. when cancelling a booking.
 */
angular.module('westBerkshireEvents.areYouSure').directive('wbAreYouSure', () => {
    return {
        restrict: 'AE',
        replace: true,
        scope: false,
        controller: WbAreYouSureController
    };
});

function WbAreYouSureController($scope, $attrs, $rootScope, $log) {
    // Store whether the user has pre-confirmed. This can be used to display an "are you sure" 
    // type message
    $scope.preConfirm = () => {
        $scope.preConfirmed = true;
    };
}


// WEBPACK FOOTER //
// ../src/public/javascripts/are-you-sure/are_you_sure.directive.js